import { ChkImage } from '@ui/checkout-components';

import { buildDataImageUri } from '../../utils/buildDataImageUri';

import type { Base64ImageProps } from './Base64Image.types';

export const Base64Image = ({
  type,
  data,
  errorComponent,
  ...props
}: Base64ImageProps) => {
  const imageSrc = buildDataImageUri(data, type);

  if (!imageSrc) {
    return errorComponent;
  }

  return <ChkImage src={imageSrc} errorComponent={errorComponent} {...props} />;
};
